<script>
export default {
  props: {
    showId: {
      type: String,
      required: true,
    },
  },
  functional: true,
  render(createElement, context) {
    const $children = context.children;
    const { showId } = context.props;
    const children = $children.filter((child, i) => {
      // do whatever I want with `child`
      return child.data.attrs.id === showId;
    });
    return createElement("div", children);
  },
};
</script>